// extracted by mini-css-extract-plugin
module.exports = {"carousel-section":"CarouselSection_carousel-section__qLdvF","header":"CarouselSection_header__DVqaa","footer":"CarouselSection_footer__dEAT4"};